import type { PlayerRecord } from '../api/types.js';

export function resolveProfileDraft(
  player: PlayerRecord | null,
  session: { userId?: string; email?: string | null; name?: string | null } | null,
): { email: string; name: string } {
  return {
    email: player?.email ?? session?.email ?? '',
    name: player?.name ?? session?.name ?? '',
  };
}
